export default {
  data() {
    return {
      modalProps: {
        visible: false,
        title: "",
      },
    };
  },
  methods: {
    updateModalProps(nextModalProps = {}) {
      this.modalProps = {
        ...this.modalProps,
        ...nextModalProps,
      };
    },
    updateModalVisible(visible) {
      this.updateModalProps({ visible });
    },
  },
};
